module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0124.jpg?v=c20ebb7c";